import Choices from "choices.js";
import { getElements, ifSelectorExist } from "./utils";

export const choicesSelect = () => {
  const refferalFormSelect = getElements(
    ".form_select"
  );

  if (ifSelectorExist(refferalFormSelect)) {
    refferalFormSelect.forEach((selectElement) => {
      new Choices(selectElement, {
        itemSelectText: "",
        searchEnabled: false,
      });
    });
  }
};
